import { BooleanAdvancedFilterModel } from 'ag-grid-enterprise';
import { of } from 'rxjs';

import { InputDropdown } from '@camelot/form-model';

import { GridBoolCellComponent } from '../../../components/templates/bool/bool.component';
import { BaseCol, IInputOptions } from '../base-col';
import { BoolEditorComponent } from './bool-editor.component';
import { BoolFilterComponent } from './bool-filter.component';

type FilterTyping = BooleanAdvancedFilterModel;

export class BoolCol extends BaseCol<FilterTyping> {
  get value() {
    return this.filterInstance?.filterType === 'boolean' ? this.filterInstance.type : null;
  }
  public override getInputForm(options?: IInputOptions) {
    return new InputDropdown({
      key: this.key,
      label: options?.fromView ? '' : !options?.fromEdit ? this.inputLabel : '',
      value: options?.value ?? this.value,
      class: 'pb-2',
      options: of([
        {
          id: 'true',
          name: 'grid.common.true',
        },
        {
          id: 'false',
          name: 'grid.common.false',
        },
      ]),
    });
  }
  public override getFiltersModel(data: any): FilterTyping | null {
    const value = data[this.key];

    return {
      filterType: 'boolean',
      colId: this.key,
      type: value,
    };
  }

  public override getColDef() {
    return {
      ...super.getColDef(),
      ...{ cellEditor: BoolEditorComponent, cellRenderer: GridBoolCellComponent, filter: BoolFilterComponent },
    };
  }
}
